import {h, Fragment} from "preact"
import { useAppState, HistoryElement, AutocompleteElement } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks";
import { defaultConfig, topSearches, SEARCH_DROPDOWN_REC_ID } from "../config"
import { closeSearch } from "../helpers"

export default function History() {
    const { historyItems } = useAppState();
    const historyElRef = useRef(null);
    const [ topDistance, setTopDistance ] = useState(0);

    useEffect(() => {
        if(!window.nostojs) return
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ SEARCH_DROPDOWN_REC_ID ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    useEffect(() => {
        if(historyElRef.current) {
            const curTopDistance = historyElRef.current.getBoundingClientRect().top;
            if(curTopDistance !== topDistance && curTopDistance !== 0) {
                historyElRef.current.style.setProperty('--top-distance', curTopDistance + 'px')
                setTopDistance(curTopDistance);
            }
        }
    }, [ historyElRef ])

    return (
        <div class="ns-autocomplete" ref={historyElRef}>
            <div class="ns-autocomplete-inner ns-flex ns-flex-col ns-lg-flex-row">

                <div class="ns-autocomplete-section ns-keywords-section ns-flex ns-flex-nowrap ns-lg-flex-col ns-lg-flex-wrap">
                    {/* TOP SEARCHES */}
                    {topSearches?.length > 0 && (
                        <div class="ns-popular-searches">
                            <div class="ns-section-header">
                                <h4 class="ns-section-heading">
                                    Top Searches
                                </h4>
                            </div>
                            <ul class="ns-keyword-list ns-flex ns-flex-col list-unstyled">
                                {topSearches?.slice(0, defaultConfig.historySize).map(item => (
                                    <li key={item.text}>
                                        {item.url ? (
                                            <AutocompleteElement as="a" hit={{ url: item.url }} class="ns-keyword-item ns-block">
                                                {item.text}
                                            </AutocompleteElement>
                                        ) : (
                                            <HistoryElement query={{ query: item.text }} class="ns-keyword-item">
                                                {item.text}
                                            </HistoryElement>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}

                    {/* RECENT SEARCHES */}
                    {historyItems?.length > 0 && (
                        <div class="ns-recent-searches">
                            <div class="ns-section-header">
                                <h4 class="ns-section-heading">
                                    Recent Searches
                                </h4>
                            </div>
                            <ul class="ns-keyword-list ns-flex ns-flex-col list-unstyled">
                                {historyItems?.slice(0, defaultConfig.historySize).map(item => (
                                    <li key={item}>
                                        <HistoryElement query={{ query: item }} class="ns-keyword-item">
                                            {item}
                                        </HistoryElement>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>

                {/* PRODUCTS */}
                <div class="nosto_element ns-autocomplete-section ns-products-section" id={SEARCH_DROPDOWN_REC_ID}></div>

            </div>
        </div>
    )
}
